module.exports = __webpack_public_path__ + "img/Modal Event - Tag shadow.50152e78.png";